import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { verifiedPurchases } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    const hide = window.setTimeout(() => setVisible(false), 14000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % verifiedPurchases.length);
    }, 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [index, dismissed]);
  const purchase = verifiedPurchases[index];
  return <AnimatePresence data-id="element-193" data-mp="f7i8iandesoh">
      {visible && !dismissed && <motion.aside initial={{
      opacity: 0,
      x: -16
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -16
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-24 left-4 z-40 w-[17rem] rounded-xl border border-gold-soft/30 bg-night-panel p-4 shadow-xl" data-id="element-194" data-mp="b2seysg6pq6q">
          <div className="flex items-start justify-between gap-3" data-id="element-195" data-mp="286sfttiy6gmn">
            <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-196" data-mp="283wk8buko41d">
              ● Compra verificada
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="text-parchment/45 transition-colors duration-150 ease-out hover:text-parchment focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft" data-id="element-197" data-mp="1fiekxmn5o0fb">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-198" data-mp="wqlotjcshz3d" />
            </button>
          </div>

          <p className="mt-2 font-sans text-sm text-parchment" data-id="element-199" data-mp="201hnrp1i935o">
            <span className="font-semibold" data-id="element-200" data-mp="1zzwwq9eeg2ck">{purchase.name}</span> de {purchase.city}
          </p>
          <p className="font-sans text-sm text-parchment/70" data-id="element-201" data-mp="1v0twr3da0mbg">
            compró <span className="font-semibold text-gold-soft" data-id="element-202" data-mp="28t1ky6qhv4yj">GPS Bíblico 🙏</span>
          </p>
          <p className="mt-1 font-sans text-xs text-parchment/45" data-id="element-203" data-mp="24u12ipbxi4c2">{purchase.time}</p>
        </motion.aside>}
    </AnimatePresence>;
}